import { ErrorCode } from '@app/origami-api/constants/error-codes';
import { tiStringsFormat } from '@app/shared/pipes/string-format.pipe';
import { getServerConfig } from '@app/origami-api/server-config';
import { getErrorDescription } from '@app/origami-api/utils/error-utils';

export function parseBulkImportUsersError(usersResult: any[]) {
  let entityType = { user: 'U', group: 'G' },
    succeedUsers = [],
    failedUsers = [],
    addedToRoom = 0,
    totalUsers = 0;

  usersResult.forEach((userError) => {
    if (userError.ObjectType === entityType.user) {
      totalUsers++;

      const user = {
        id: userError.ObjectId,
        name: userError.ObjectName,
        errors: [],
      };
      if (userError.ErrorCode !== 0) {
        user.errors.push({ code: userError.ErrorCode, type: entityType.user, originalError: userError });
      } else {
        addedToRoom++;
        usersResult.forEach((groupError) => {
          if (groupError.ObjectType !== entityType.group) {
            return;
          }

          if (groupError.ObjectId === userError.ObjectId && groupError.ErrorCode !== 0) {
            user.errors.push({
              originalError: groupError,
              code: groupError.ErrorCode,
              type: entityType.group,
              group: groupError.ObjectName,
            });
          }
        });
      }

      if (user.errors.length > 0) {
        failedUsers.push(user);
      } else {
        succeedUsers.push(user);
      }
    }
  });

  let errorHeader,
    errorMessages = [];

  if (failedUsers.length > 0) {
    errorHeader = tiStrings.app.misc.createUserErrorHeader;

    failedUsers.forEach((user) => {
      user.errors.forEach((error) => {
        let message;

        if (error.code === ErrorCode.SPONSOR_CONTACT_ID_FIELD_SHOULD_BE_UNIQUE) {
          message = tiStringsFormat(tiStrings.app.misc.sponsorContactIdIssue2, error.originalError.RelatedObjectName);
        } else if (error.code === ErrorCode.CREATE_DEACTIVATED_USER_ERROR) {
          message = tiStringsFormat(tiStrings.app.misc.createDeactivatedUserError, getServerConfig().supportEmail);
        } else {
          message = getErrorDescription(error.code);
        }

        if (error.type === entityType.user) {
          errorMessages.push(tiStringsFormat(tiStrings.app.misc.createUserError, user.name, message));
        } else if (error.type === entityType.group) {
          errorMessages.push(tiStringsFormat(tiStrings.app.misc.addUserToGroupError, user.name, error.group, message));
        } else {
          errorMessages.push(message);
        }
      });
    });
  }

  return {
    addedToSite: addedToRoom,
    totalUsers: totalUsers,
    succeedUsers: succeedUsers,
    failedUsers: failedUsers,
    errorHeader: errorHeader,
    errorMessages: errorMessages,
    totalSuccess: addedToRoom,
    totalFailed: totalUsers - addedToRoom,
    getErrorMessagesText: function (separator, addHeader) {
      if (errorHeader) {
        return (addHeader ? errorHeader + separator : '') + errorMessages.join(separator);
      }
      return '';
    },
  };
}
